import * as d3 from "d3";
import {axisTextDim1, numberFormat, responsivefy, XaxisAttribute} from '../functions'

export default function (chart, divId, vizName, resData) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (chart.axisLabelFontSize - 10) + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(res => {
        let data = resData
        var hoverLine = false;
        var landscape = true;

        d3.select(".sort-by")
            .on("change", function () {
                var attribute = d3.select(this).property("value");
                sortLollipops(attribute, 1);
            });

        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + 2 * chart.margin.left + "," + chart.margin.top + ")");

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom - 6 * chart.axisLabelDistance)
            .attr('fill', fontColor)
            .attr('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left - 20 * chart.axisLabelDistance)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1.5em') // changed 1em to 1.5em in order to visible clear
            .attr('fill', fontColor)
            .attr('font-size', fontSize)
            .style('text-anchor', 'middle')
            .text(chart.y1AxisDisplayName)

        function sortBy(data, attribute, order) {
            data.sort(function (a, b) {
                if (a[attribute] < b[attribute]) return -1 * order;
                if (a[attribute] > b[attribute]) return 1 * order;
                return 0;
            });
        }

        // need to rewrite so start, min, lowest are the same
        var classToPos = {
            "lollipop-start": "metric1",
            "lollipop-average": "metric2",
            "lollipop-end": "metric3"
        }

        var legendLabels = [
            {label: "Median", class: "lollipop-start"},
            {label: "Average", class: "lollipop-average"},
            {label: "Highest", class: "lollipop-end"}
        ];

        var legendX = 300, legendY = -50, spaceBetween = 80;

        // code for positioning legend
        var y1legend = svg.append("g").attr("transform", "translate(" + [legendX, legendY] + ")");
        // Try using Susie Lu's d3-legend  add circles
        y1legend.selectAll("circle")
            .data(legendLabels)
            .enter()
            .append("circle")
            .attr("cx", function (d, i) {
                return spaceBetween * i;
            })
            .attr("cy", -4)
            .attr("r", 5)
            .attr("class", function (d) {
                return d.class
            })

        // add labels
        y1legend.append("g")
            .selectAll("text")
            .data(legendLabels)
            .enter()
            .append("text")
            .attr("x", function (d, i) {
                return spaceBetween * i + 10;
            })
            .text(function (d) {
                return d.label
            });

        // Append div
        var y1tip = d3.select(divId)
            .append("div")
            .attr("class", "tooltip")
            .style('position', 'relative')
            .style('line-height', '1')
            .style('padding', '12px')
            .style('background', 'white')
            .style('border-radius', '5px')
            .style('position', 'absolute')
            .style('border-width', '.5px')
            .style('border-style', 'groove')

        var metric1ColorScale = {
            median: "#808080",
            average: "white",
            max: "#0000FF"
        };

        var x1Scale = d3.scaleLinear().range([0, chart.width]);
        var y1Scale = d3.scaleBand().range([0, chart.height]).paddingInner(0.5).paddingOuter(0.7);

        var lineGenerator = d3.line();

        var axisLinePath = function (d) {
            return lineGenerator([[x1Scale(d) + 0.5, 0], [x1Scale(d) + 0.5, chart.height]]);
        };

        var lollipopLinePath = function (d) {
            return lineGenerator([[x1Scale(d.metric1), 0], [x1Scale(d.metric3), 0]]);
        };

        var selectionLine, lollipops, yAxisGroup, xAxisGroup, axisLines, lollipopsGroup;
        var startCircles, averageCircles, endCircles;

        // Make global for now
        var payRatios;
        payRatios = data

        // use -1 to flip ordering
        sortBy(payRatios, "dim1_name", 1);

        x1Scale.domain([0, d3.max(payRatios, function (d) {
            return d.metric3
        })]);
        x1Scale.nice();
        y1Scale.domain(payRatios.map(function (d) {
            return d.dim1_name
        }));

        var x1AxisLabel = d3.axisBottom().scale(x1Scale).tickFormat(d => numberFormat(d));
        var x2AxisLabel = d3.axisTop().scale(x1Scale).tickFormat(d => numberFormat(d));
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickSize(0);

        yAxisGroup = svg.append("g").attr("class", "y-axis-group");

        // at loading time
        yAxisGroup.append("g")
            .attr("class", "y-axis")
            .call(y1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .style('text-anchor', 'start')
            .attr('dx', XaxisAttribute)
            .text(axisTextDim1)
            .attr("transform", "translate(-20, 0)")
            .select(".domain")
            .attr("opacity", 0);

        xAxisGroup = svg.append("g").attr("class", "x-axis-group");

        xAxisGroup.append("g")
            .attr("class", "x-axis")
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisLabelFontSize)
            .attr("transform", "translate(0," + chart.height + ")");

        xAxisGroup.append("g")
            .attr("class", "x-axis")
            .call(x2AxisLabel)
            .style('font-size', axisLabelFontSize)

        axisLines = svg.append("g").attr("class", "grid-lines");

        axisLines.selectAll("path")
            .data(x1Scale.ticks())
            .enter()
            .append("path")
            .attr("class", "grid-line")
            .attr("d", axisLinePath);

        selectionLine = xAxisGroup.append("g")
            .attr("class", "interactive")
            .append("path")
            .attr("class", "selection-line")
            .attr("d", () => {
                return lineGenerator([[chart.width / 2, 0], [chart.width / 2, chart.height]])
            })
            .attr("opacity", 0);

        lollipopsGroup = svg.append("g").attr("class", "lollipops");

        lollipops = lollipopsGroup.selectAll("g")
            .data(payRatios)
            .enter()
            .append("g")
            .attr("class", "lollipop")
            .attr("transform", (d) => "translate(0," + (y1Scale(d.dim1_name) + (y1Scale.bandwidth() / 2) + ")"))

        lollipops.append("path")
            .attr("class", "lollipop-line")
            .attr("d", lollipopLinePath);

        startCircles = lollipops.append("circle")
            .attr("class", "lollipop-start")
            .attr("r", 5)
            .attr("cx", (d) => {
                return x1Scale(d.metric1);
            })
            .on("mouseover", showLabel)
            .on("mousemove", moveLabel)
            .on("mouseout", hideLabel)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        averageCircles = lollipops.append("circle")
            .attr("class", "lollipop-average")
            .attr("r", function (d) {
                if (d.metric2 === "N/A") {
                    return 0;
                } else {
                    return 5;
                }
            })
            .attr("cx", function (d) {
                if (d.metric2 === "N/A") {
                    return 0;
                } else {
                    return x1Scale(d.metric2);
                }
            })
            .on("mouseover", showLabel)
            .on("mousemove", moveLabel)
            .on("mouseout", hideLabel)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        endCircles = lollipops.append("circle")
            .attr("class", "lollipop-end")
            .attr("r", 5)
            .attr("cx", (d) => {
                return x1Scale(d.metric3)
            })
            .on("mouseover", showLabel)
            .on("mousemove", moveLabel)
            .on("mouseout", hideLabel)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        console.warn(startCircles, averageCircles, endCircles)

        function showLabel() {
            var selection = d3.select(this);
            var pos = classToPos[selection.attr("class")];
            var data = d3.select(this.parentNode).datum();

            y1tip.transition()
                .duration(100)
                .style("opacity", 0.9)

            y1tip.html((selection.datum()[pos]))
                .style("left", (d3.event.layerX) + "px")
                .style("top", (d3.event.layerY) + "px")
                .style("background-color", metric1ColorScale)

            if (hoverLine) {
                selectionLine.attr("d", function () {
                    if (landscape) {
                        return lineGenerator([[x1Scale(data[pos]), 0], [x1Scale(data[pos]), chart.height]]);
                    } else {
                        return lineGenerator([[0, x1Scale(data[pos])], [chart.width, x1Scale(data[pos])]]);
                    }
                })
                    .attr("opacity", 0.75);
            }
        }

        function moveLabel() {
            y1tip.style("left", (d3.event.layerX) + "px")
                .style("top", (d3.event.layerY) + "px")
        }

        function hideLabel() {
            y1tip.transition().duration(200).style("opacity", 0);

            selectionLine.attr("opacity", 0);
        }

        function sortLollipops(attribute, ordering) {
            sortBy(payRatios, attribute, 1);

            y1Scale.domain(payRatios.map(function (d) {
                return d.dim1_name
            })).copy();

            console.warn(sortLollipops(), ordering)
            if (landscape) {
                lollipops.transition()
                    .attr("transform", function (d) {
                        return "translate(" + [0, (y1Scale(d.dim1_name) + y1Scale.bandwidth() / 2)] + ")";
                    });

                yAxisGroup.select(".y-axis").transition().call(y1AxisLabel);
            } else {
                lollipops.transition()
                    .attr("transform", function (d) {
                        return "translate(" + [(y1Scale(d.dim1_name) + y1Scale.bandwidth() / 2), 0] + ")";
                    });

                xAxisGroup.select(".x-axis").transition().call(y1AxisLabel);
            }
        }

        //               d3.select("svg").on("click", switchBetweenPortraitAndLandscape);

        console.warn(switchBetweenPortraitAndLandscape)

        function recalculateMargin(newMargin) {
            d3.select("svg").select("g")
                .attr("transform", "translate(" + newMargin.left + "," + newMargin.top + ")")
        }

        function switchBetweenPortraitAndLandscape() {
            if (landscape) {
                landscape = false;
                // Redraw xAxis
                x1Scale.range([chart.height, 0]);

                x1AxisLabel = d3.axisLeft().scale(x1Scale).tickFormat((d) => numberFormat(d));
                x2AxisLabel = d3.axisRight().scale(x1Scale).tickFormat((d) => numberFormat(d));

                yAxisGroup.select(".y-axis")
                    .call(x1AxisLabel)
                    .attr("transform", "translate(0, 0)")
                    .select(".domain")
                    .attr("opacity", 1);

                // Redraw yAxis
                y1Scale.range([0, chart.width]);

                y1AxisLabel = d3.axisBottom().scale(y1Scale).tickSize(0);

                xAxisGroup.select(".x-axis")
                    .call(y1AxisLabel)
                    .attr("transform", "translate(0," + chart.height + ")")
                    .select(".domain")
                    .attr("opacity", 0);

                xAxisGroup.select(".x-axis")
                    .selectAll("text")
                    .attr("dx", XaxisAttribute)
                    .attr("transform", "rotate(-50)")
                    .style("text-anchor", "start")
                    .text(axisTextDim1);

                // Redraw lollipops
                lollipops.attr("transform", function (d) {
                    return "translate(" + [(y1Scale(d.dim1_name) + (y1Scale.bandwidth() / 2)), 0] + ")";
                });

                lollipops.select(".lollipop-line")
                    .attr("d", (d) => {
                        return lineGenerator([[0, x1Scale(d.metric1)], [0, x1Scale(d.metric3)]])
                    })
                lollipops.select(".lollipop-start")
                    .attr("cy", (d) => {
                        return x1Scale(d.metric1)
                    })
                    .attr("cx", 0);
                lollipops.select(".lollipop-average")
                    .attr("cy", function (d) {
                        if (d.metric2 === "N/A") {
                            return 0;
                        } else {
                            return x1Scale(d.metric2);
                        }
                    })
                    .attr("cx", 0);

                lollipops.select(".lollipop-end")
                    .attr("cy", function (d) {
                        return x1Scale(d.metric3);
                    })
                    .attr("cx", 0);

                // Redraw grid lines
                axisLines.selectAll(".grid-line")
                    .attr("d", function (d) {
                        return lineGenerator([[0, x1Scale(d) + 0.5], [chart.width, x1Scale(d) + 0.5]]);
                    });

                // Move legend
                y1legend.attr("transform", "translate(" + [legendX + 40, legendY] + ")");
            } else {
                landscape = true;

                recalculateMargin(chart.margin);

                // Redraw xAxis
                x1Scale.range([0, chart.width]);

                x1AxisLabel = d3.axisBottom().scale(x1Scale).tickFormat((d) => numberFormat(d));

                xAxisGroup.select(".x-axis")
                    .call(x1AxisLabel)
                    .attr("transform", "translate(0," + chart.height + ")")
                    .select(".domain")
                    .attr("opacity", 1);

                // Redraw yAxis
                y1Scale.range([0, chart.height]);

                y1AxisLabel = d3.axisLeft().scale(y1Scale).tickSize(0);

                //second click y-axis
                yAxisGroup.select(".y-axis")
                    .call(y1AxisLabel)
                    .selectAll('text')
                    .style('text-anchor', 'start')
                    .attr('dx', XaxisAttribute)
                    .text(axisTextDim1)
                    .attr("transform", "translate(-20, 0)")
                    .select(".domain")
                    .attr("opacity", 0);

                // Redraw lollipops
                lollipops.attr("transform", function (d) {
                    return "translate(0," + (y1Scale(d.dim1_name) + (y1Scale.bandwidth() / 2)) + ")";
                });

                lollipops.select(".lollipop-line")
                    .attr("d", function (d) {
                        return lineGenerator([[x1Scale(d.metric1), 0], [x1Scale(d.metric3), 0]]);
                    })
                lollipops.select(".lollipop-start")
                    .attr("cx", function (d) {
                        return x1Scale(d.metric1);
                    })
                    .attr("cy", 0);
                lollipops.select(".lollipop-average")
                    .attr("cx", function (d) {
                        if (d.metric2 === "N/A") {
                            return 0;
                        } else {
                            return x1Scale(d.metric2);
                        }
                    })
                    .attr("cy", 0);
                lollipops.select(".lollipop-end")
                    .attr("cx", function (d) {
                        return x1Scale(d.metric3)
                    })
                    .attr("cy", 0);

                // Redraw grid lines
                axisLines.selectAll(".grid-line").attr("d", axisLinePath);

                // Reposition legend
                y1legend.attr("transform", "translate(" + [legendX, legendY] + ")");
            }
        }
    // });
}
